import React from 'react';
import { Loader, BaasicModal, BaasicTable, BaasicConfirmModal, BaasicHeader, BaasicSelect } from 'core/components';
import { UserEdit, UserCreate, UserPasswordChange } from 'modules/user/pages';
import { defaultTemplate } from 'core/hoc';

const UserListTemplate = ({
	t,
	viewStore,
	viewStore: { listStore, tableData, queryUtility, userName, 	sellerOptions, onSellerChange, selectedSeller, isSuperAdmin },
	headerCell,
	actions,
	showActions,
}) => {
	if (
		viewStore.loading &&
		!viewStore.createModal.isOpen &&
		!viewStore.editModal.isOpen &&
		!viewStore.passwordChangeModal.isOpen
	)
		return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader
				title="MAINMENU.ADMINISTRATION.USERS"
			>
				{isSuperAdmin == true &&
					<BaasicSelect
						placeholder={t('PLACEHOLDER.ORGANIZATION')}
						options={sellerOptions}
						value={selectedSeller}
						isClearable={true}
						onChange={onSellerChange}
						className="w--200--px"
					/>}
			</BaasicHeader>
			<BaasicTable
				{...{
					listStore,
					tableData,
					queryUtility,
					viewStore,
					headerCell,
					actions,
					showActions,
				}}
				data={listStore.data.slice()}
			/>
			<BaasicModal modalParams={viewStore.editModal}>
				<UserEdit userName={userName} />
			</BaasicModal>
			<BaasicModal modalParams={viewStore.createModal}>
				<UserCreate />
			</BaasicModal>
			<BaasicModal modalParams={viewStore.passwordChangeModal}>
				<UserPasswordChange />
			</BaasicModal>
			<BaasicConfirmModal modalParams={viewStore.deleteConfirmModal} />
		</section>
	);
};

export default defaultTemplate(UserListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/user/pages/UserListTemplate.jsx